import types from '../test-overview/types';

const { GET_TEST_TRENDS, GET_AGGREGATED_TEST_ERRORS, GET_TESTS_BY_ERROR, CHANGE_PAGE } = types;

export const NAMESPACE = 'analytics-test-error-rdc';

export const CLEANUP_TEST_ERROR = `${NAMESPACE}/CLEANUP_TEST_ERROR`;
export { GET_TEST_TRENDS, GET_AGGREGATED_TEST_ERRORS, GET_TESTS_BY_ERROR, CHANGE_PAGE };
